import { type CandidateStatus } from "./candidate";
import { type Job } from "./job";

/**
 * Stepper step indices used across the Dashboard and card headers.
 * Maps 1:1 to PROCESS_STEPS in @vidario/ui (Kandidatensuche → Longlist
 * → Qualifizierung → Empfehlung → Platziert). Rejected candidates
 * don't advance the stepper — per MVP_requirements.md §5.1 it follows
 * the furthest-advanced active candidate. `selected` stays at Longlist
 * because the job only enters Qualifizierung once a candidate is
 * actively in `outreach`.
 */
export const STEP_INDEX: Record<CandidateStatus, number> = {
  pool: 0,
  longlist: 1,
  selected: 1,
  outreach: 2,
  prequal: 2,
  interview: 2,
  // An unreleased recommendation shows the recruiter Qualifizierung (ADR 0004).
  in_review: 2,
  recommendation: 3,
  placed: 4,
  rejected: -1,
};

/** What a Dashboard card or table row shows, from `/jobs/summary` — the
 * job's description, tasks and criteria aren't part of it (#13).
 * `currentStep` is 0–4 matching the ProcessStepper's 5 steps; `-1` means
 * no active candidates. */
export interface JobSummary extends Pick<
  Job,
  | "id"
  | "title"
  | "company"
  | "location"
  | "workModel"
  | "status"
  | "createdBy"
  | "assignedRecruiters"
  | "createdAt"
> {
  candidateCount: number;
  currentStep: number;
}

export function furthestStep(statuses: readonly CandidateStatus[]): number {
  let max = -1;
  for (const s of statuses) {
    const idx = STEP_INDEX[s];
    if (idx > max) max = idx;
  }
  return max;
}
